import {
  GET_ADGROUP_NOTES,
  GET_ADGROUP_NOTES_SUCCESS,
  GET_ADGROUP_NOTES_ERROR,
  CREATE_ADGROUP_NOTES,
  CREATE_ADGROUP_NOTES_SUCCESS,
  CREATE_ADGROUP_NOTES_ERROR,
  UPDATE_ADGROUP_NOTES,
  UPDATE_ADGROUP_NOTES_SUCCESS,
  UPDATE_ADGROUP_NOTES_ERROR,
  DELETE_ADGROUP_NOTES,
  DELETE_ADGROUP_NOTES_SUCCESS,
  DELETE_ADGROUP_NOTES_ERROR,
} from "./actionTypes";

/* GET ADGROUP NOTES */
export const getAdgroupNotes = (action) => ({
  type: GET_ADGROUP_NOTES,
  payload: action
});

export const getAdgroupNotesSuccess = (data) => ({
  type: GET_ADGROUP_NOTES_SUCCESS,
  payload: data,
});

export const getAdgroupNotesError = (error) => ({
  type: GET_ADGROUP_NOTES_ERROR,
  payload: error,
});

/* CREATE ADGROUP NOTES */
export const createAdgroupNotes = (newNotes) => ({
  type: CREATE_ADGROUP_NOTES,
  payload: newNotes,
});

export const createAdgroupNotesSuccess = (data) => ({
  type: CREATE_ADGROUP_NOTES_SUCCESS,
  payload: data,
});

export const createAdgroupNotesError = (error) => ({
  type: CREATE_ADGROUP_NOTES_ERROR,
  payload: error,
});

/* UPDATE ADGROUP NOTES */
export const updateAdgroupNotes = (notes) => ({
  type: UPDATE_ADGROUP_NOTES,
  payload: notes,
});

export const updateAdgroupNotesSuccess = (data) => ({
  type: UPDATE_ADGROUP_NOTES_SUCCESS,
  payload: data,
});

export const updateAdgroupNotesError = (error) => ({
  type: UPDATE_ADGROUP_NOTES_ERROR,
  payload: error,
});

/* DELETE ADGROUP NOTES */
export const deleteAdgroupNotes = (notesId) => ({
  type: DELETE_ADGROUP_NOTES,
  payload: notesId,
});

export const deleteAdgroupNotesSuccess = (data) => ({
  type: DELETE_ADGROUP_NOTES_SUCCESS,
  payload: data,
});

export const deleteAdgroupNotesError = (error) => ({
  type: DELETE_ADGROUP_NOTES_ERROR,
  payload: error,
});
